<template>
  <div class="w-full flex flex-col justify-center">
    <div class="self-center w-fit">
      <NuxtLink to="/">
        <img
          src="/hurst-logo-white-background.svg"
          alt="Logo da Hurst"
          class="w-[160px] h-[64px] md:w-[266px] sm:h-[115px]"
        />
      </NuxtLink>
    </div>
  </div>
</template>
